import { round } from 'lodash'

/**
 * 修正尺寸
 */
export const amendSize = (value: number) =>
  isNaN(value) || value === 0 ? 1 : round(value)

/**
 *  转换百分比
 */
export const toPercentage = (value: number) => {
  return value * 100 + '%'
}
